if (!customElements.get("product-collection-feature")) {
  class ProductCollectionFeature extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === "true") return;

      this.dataset.initialized = "true";
      this.track = this.querySelector(".product-collection-feature__thumbnails");
      this.navigation = this.querySelector(".product-collection-feature__navigation");
      this.progress = this.querySelector(".product-collection-feature__progress");
      this.progressThumb = this.querySelector(".product-collection-feature__progress-thumb");
      this.previousButton = this.querySelector(".product-collection-feature__arrow--previous");
      this.nextButton = this.querySelector(".product-collection-feature__arrow--next");
      this.mobileMedia = window.matchMedia("(max-width: 989px)");
      this.frame = null;

      if (!this.track || !this.navigation) return;

      this.onArrowClick = this.onArrowClick.bind(this);
      this.onResize = this.onResize.bind(this);
      this.onScroll = this.onScroll.bind(this);

      this.track.addEventListener("scroll", this.onScroll, { passive: true });
      this.previousButton?.addEventListener("click", this.onArrowClick);
      this.nextButton?.addEventListener("click", this.onArrowClick);
      window.addEventListener("resize", this.onResize);
      window.requestAnimationFrame(() => this.update());
    }

    disconnectedCallback() {
      if (!this.track) return;

      this.track.removeEventListener("scroll", this.onScroll);
      this.previousButton?.removeEventListener("click", this.onArrowClick);
      this.nextButton?.removeEventListener("click", this.onArrowClick);
      window.removeEventListener("resize", this.onResize);
      window.cancelAnimationFrame(this.frame);
    }

    onArrowClick(event) {
      const firstItem = this.track.querySelector(".product-collection-feature__thumbnail-item");
      if (!firstItem) return;

      const gap = Number.parseFloat(getComputedStyle(this.track).columnGap) || 0;
      const step = firstItem.getBoundingClientRect().width + gap;
      const direction = event.currentTarget.dataset.collectionFeatureDirection === "previous" ? -1 : 1;
      const currentIndex = Math.round(this.track.scrollLeft / step);
      const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

      this.track.scrollTo({
        behavior: prefersReducedMotion ? "auto" : "smooth",
        left: (currentIndex + direction) * step,
      });
    }

    onResize() {
      this.scheduleUpdate();
    }

    onScroll() {
      this.scheduleUpdate();
    }

    scheduleUpdate() {
      window.cancelAnimationFrame(this.frame);
      this.frame = window.requestAnimationFrame(() => this.update());
    }

    update() {
      const maxScroll = this.track.scrollWidth - this.track.clientWidth;
      const hasOverflow = maxScroll > 1;
      const isMobile = this.mobileMedia.matches;

      this.navigation.hidden = !isMobile || !hasOverflow;
      this.previousButton.disabled = !hasOverflow || this.track.scrollLeft <= 1;
      this.nextButton.disabled = !hasOverflow || this.track.scrollLeft >= maxScroll - 1;

      if (!isMobile || !hasOverflow || !this.progress || !this.progressThumb) return;

      const progressWidth = this.progress.clientWidth;
      const thumbWidth = Math.min(65, progressWidth);
      const scrollRatio = Math.max(0, Math.min(1, this.track.scrollLeft / maxScroll));
      const thumbOffset = (progressWidth - thumbWidth) * scrollRatio;

      this.progressThumb.style.width = `${thumbWidth}px`;
      this.progressThumb.style.transform = `translateX(${thumbOffset}px)`;
    }
  }

  customElements.define("product-collection-feature", ProductCollectionFeature);
}
